import React from "react";
import BaseSubscriptionPopup from "../Popup/BaseSubscriptionPopup";

const CustomerCareSubscriptionPopup = ({ isOpen, onClose, title, onSubscriptionBtnClick }) => {
  return (
    <BaseSubscriptionPopup isOpen={isOpen} onClose={onClose} title={title} onSubscriptionBtnClick={onSubscriptionBtnClick}>
        <div className="mb-5">
      <p className="text-subscription text-center f-16">
        Is your request urgent? premium users can get their queries resolved by
        one of our dedicated customer care reps.
      </p>
      <p className="text-subscription text-center f-16">
        Premium users also get access to a host of additional benefits!
      </p>
      </div>
    </BaseSubscriptionPopup>
  );
};

export default CustomerCareSubscriptionPopup;
